/** Dados agregados do relatório diário (API `relatorio-dia.php`). */
export interface RelatorioDiaCompleto {
  date: string;
  faturamento: number;
  faturamento_total: number;
  pagamentos: { credito: number; debito: number; dinheiro: number; pix: number };
  desperdicios: number;
  dinheiro_recebido: number;
  troco_total: number;
  valor_em_caixa: number;
  top_produtos: TopProdutoDia[];
  vendas_por_hora: VendaHoraDia[];
  /** Horas (0–23) com maior volume; vazio se não houver vendas. */
  horarios_pico: number[];
}

export interface TopProdutoDia {
  nome: string;
  quantidade: number;
  valor_total: number;
}

export interface VendaHoraDia {
  hora: number;
  quantidade: number;
}

/** Normaliza resposta da API (instalações antigas sem campos novos). */
export function normalizarRelatorioDia(raw: Record<string, unknown>): RelatorioDiaCompleto {
  const pag = (raw.pagamentos as RelatorioDiaCompleto["pagamentos"]) ?? {
    credito: 0,
    debito: 0,
    dinheiro: 0,
    pix: 0,
  };
  const fat = Number(raw.faturamento ?? 0) || 0;
  const fatTotalRaw = raw.faturamento_total != null ? Number(raw.faturamento_total) : fat;
  const fatTotal = Number.isFinite(fatTotalRaw) ? Math.round(fatTotalRaw * 100) / 100 : 0;
  return {
    date: String(raw.date ?? ""),
    faturamento: fat,
    faturamento_total: fatTotal,
    pagamentos: {
      credito: Number(pag.credito ?? 0),
      debito: Number(pag.debito ?? 0),
      dinheiro: Number(pag.dinheiro ?? 0),
      pix: Number(pag.pix ?? 0),
    },
    desperdicios: Number(raw.desperdicios ?? 0),
    dinheiro_recebido: Number(raw.dinheiro_recebido ?? 0),
    troco_total: Number(raw.troco_total ?? 0),
    valor_em_caixa: Number(raw.valor_em_caixa ?? 0),
    top_produtos: Array.isArray(raw.top_produtos)
      ? (raw.top_produtos as TopProdutoDia[]).map((p) => ({
          nome: String(p.nome ?? ""),
          quantidade: Number(p.quantidade ?? 0),
          valor_total: Number(p.valor_total ?? 0),
        }))
      : [],
    vendas_por_hora: Array.isArray(raw.vendas_por_hora)
      ? (raw.vendas_por_hora as VendaHoraDia[]).map((h) => ({
          hora: Number(h.hora ?? 0),
          quantidade: Number(h.quantidade ?? 0),
        }))
      : [],
    horarios_pico: (() => {
      const fromApi = Array.isArray(raw.horarios_pico)
        ? (raw.horarios_pico as number[]).map((h) => Number(h))
        : [];
      if (fromApi.length > 0) return fromApi;
      const porHora = Array.isArray(raw.vendas_por_hora)
        ? (raw.vendas_por_hora as VendaHoraDia[]).map((h) => ({
            hora: Number(h.hora ?? 0),
            quantidade: Number(h.quantidade ?? 0),
          }))
        : [];
      let max = 0;
      for (const v of porHora) {
        if (v.quantidade > max) max = v.quantidade;
      }
      if (max < 0.00001) return [];
      return porHora.filter((v) => Math.abs(v.quantidade - max) < 0.00001).map((v) => v.hora);
    })(),
  };
}
